import { TAccountDetailsNavigationItem } from '@pb/shared/ui/organisms/account-details';
import { getEnvironmentSettings, TLoggedInUser, logOut } from '@pb/services';

export function getCustomerNavigationMenuItems(
    data: TLoggedInUser | undefined,
    handleAccountMenuClick: (
        event: React.MouseEvent<Element, MouseEvent>
    ) => void
): TAccountDetailsNavigationItem[] {
    const { baseUrl } = getEnvironmentSettings();

    return [
        {
            label: `${data?.forename} ${data?.surname}`,
            icon: 'removeOrClose',
            onClick: handleAccountMenuClick,
        },
        {
            label: 'Privacy settings',
            icon: 'lock',
            href: `${baseUrl}/account-details/privacy-settings`,
        },
        {
            label: 'Your details',
            icon: 'account',
            href: `${baseUrl}/account-details/personal-details`,
        },
        {
            label: 'Additional details',
            icon: 'mail',
            href: `${baseUrl}/account-details/sharing`,
        },
        {
            label: 'Purchase history',
            icon: 'clockwise',
            href: `${baseUrl}/account-details/invoices`,
        },
        {
            label: 'Log out',
            icon: 'arrowComplete',
            onClick: logOut,
        },
    ];
}

export function getLPPNavigationMenuItems(
    data: TLoggedInUser | undefined,
    handleAccountMenuClick: (
        event: React.MouseEvent<Element, MouseEvent>
    ) => void
): TAccountDetailsNavigationItem[] {
    const { baseUrl } = getEnvironmentSettings();

    return [
        {
            label: `${data?.forename} ${data?.surname}`,
            icon: 'removeOrClose',
            onClick: handleAccountMenuClick,
        },
        {
            label: 'Your details',
            icon: 'account',
            href: `${baseUrl}/account-details/personal-details`,
        },
        {
            label: 'Log out',
            icon: 'arrowComplete',
            onClick: logOut,
        },
    ];
}
